import React, { useState, useEffect, useRef } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { mediaApi } from '../../services/api';

export default function MediaPage() {
  const [media, setMedia] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [search, setSearch] = useState('');
  const fileRef = useRef(null);

  const fetchMedia = async () => {
    setLoading(true);
    try {
      const res = await mediaApi.list({ search, per_page: 50 });
      setMedia(res.data.data.data || res.data.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchMedia(); }, [search]); // eslint-disable-next-line react-hooks/exhaustive-deps

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    setUploading(true);
    try {
      await mediaApi.upload(formData);
      fetchMedia();
      if (fileRef.current) fileRef.current.value = '';
    } catch (err) {
      alert('Upload gagal: ' + (err.response?.data?.message || 'Unknown error'));
    } finally {
      setUploading(false);
    }
  };

  const handleCopyUrl = (url) => {
    navigator.clipboard.writeText(url).then(() => alert('URL disalin!'));
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Yakin hapus media ini?')) return;
    try {
      await mediaApi.delete(id);
      fetchMedia();
    } catch (err) {
      alert('Gagal menghapus.');
    }
  };

  return (
    <AdminLayout active="Media">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-lg font-semibold text-gray-800 mb-1">Media</h1>
        <div className="flex gap-3">
          <input type="text" placeholder="Cari file..." value={search} onChange={e => setSearch(e.target.value)} className="px-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-brand outline-none" />
          <label className={`bg-brand text-brand-dark px-5 py-2.5 rounded-xl text-sm font-semibold hover:bg-brand-dark transition-colors cursor-pointer ${uploading ? 'opacity-50 pointer-events-none' : ''}`}>
            {uploading ? 'Mengupload...' : '+ Upload'}
            <input ref={fileRef} type="file" className="hidden" onChange={handleUpload} accept="image/*" />
          </label>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
        {loading ? (
          <div className="flex justify-center py-12"><div className="w-8 h-8 border-4 border-t-transparent rounded-full animate-spin" /></div>
        ) : media.length === 0 ? (
          <div className="text-center py-12 text-gray-400">
            <span className="text-5xl block mb-4">🖼️</span>
            <p>Belum ada media. Upload gambar pertama Anda!</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">
            {media.map((item) => (
              <div key={item.id} className="group relative bg-gray-100 rounded-xl overflow-hidden aspect-square">
                {item.mime_type?.startsWith('image/') ? (
                  <img src={item.url} alt={item.alt_text || item.original_name} className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-4xl">📄</div>
                )}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center gap-2 opacity-0 group-hover:opacity-100">
                  <button onClick={() => handleCopyUrl(item.url)} className="bg-white text-gray-700 text-xs px-3 py-1.5 rounded-lg hover:bg-gray-100" title="Copy URL">📋</button>
                  <button onClick={() => handleDelete(item.id)} className="bg-red-500 text-white text-xs px-3 py-1.5 rounded-lg hover:bg-red-600" title="Hapus">🗑️</button>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-2">
                  <p className="text-white text-xs truncate">{item.original_name}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AdminLayout>
  );
}